
export const populationData = [
    {
        arg: "Ocak",
        val: 100000,
    },{
        arg: "Şubat",
        val: 250000,
    },{
        arg: "Mart",
        val: 375000,
    },{
        arg: "Nisan",
        val: 545000,
    },
];
